'use strict';

import React, { Component, Fragment } from 'react';
import uniqid from 'uniqid';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import TextInput from 'Components/Forms/Elements/TextInput';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import Visibility from '@material-ui/icons/Visibility';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import MuiPhoneNumber from 'material-ui-phone-number';
import CustomerPicking from 'Components/Back/CustomerPicking';
import getErrorsFromResponse from 'Components/Forms/Functions/getErrorsFromResponse';
import getStateFromObject from 'Components/Forms/Functions/getStateFromObject';
import handleChange from 'Components/Forms/Functions/handleChange';
import getFormData from 'Components/Forms/Functions/getFormData';
import { URL, action } from 'Shared/Routes';
import bemit from 'Functions/bemit';
import Loader from 'Pure/Loader';
let app = window.app;
const qwest = window.qwest;
export default class BackSubscriptionForm extends Component {
  state = {
    step: 0,
    create_account: false,
    search_id: uniqid(),
    status_messages: {},
    showPassword: false
  };
  handleChange = handleChange.bind(this);
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    if (props.type === 'update') {
      component.fetchSubcription();
    }
  }
  fetchSubcription = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    qwest.post('/subscription/get-all', {
      id: props.id || document.location.pathname.split('/liste-des-abonnements/')[1],
      with_count: false
    }).then(function (xhr, response) {
      const update = getStateFromObject({
        data: response.data[0],
        model: 'subscription'
      });
      component.setState({
        ...update,
        loading: false
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  searchCustomer = () => {
    const component = this,
      props = this.props,
      state = this.state;
    qwest.post(action('getAllUsers'), {
      searched: state.customer_searched,
      role: "customer",
      with_count: false
    }).then(function (xhr, response) {
      component.setState({
        cutomer_search_result: response.data,
        loading: false
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  nextStep = e => {
    const component = this,
      props = this.props,
      state = this.state;
    if (state.step === 0) {
      if (state['user[lastname]'] === "") {
        return component.setState({
          status_messages: {
            'user[lastname]': {
              error: "Champ requis"
            }
          }
        });
      }
      if (state['user[firstname]'] === "") {
        return component.setState({
          status_messages: {
            'user[firstname]': {
              error: "Champ requis"
            }
          }
        });
      }
      if (state['user[login]'] === "") {
        return component.setState({
          status_messages: {
            'user[login]': {
              error: "Champ requis"
            }
          }
        });
      }
      if (state['user[password]'] === "") {
        return component.setState({
          status_messages: {
            'user[password]': {
              error: "Champ requis"
            }
          }
        });
      }
      if (state['user[password]'] !== state["password-verification"]) {
        return component.setState({
          status_messages: {
            'password-verification': {
              error: "Les mots de passe ne correspondent pas"
            }
          }
        });
      }
      component.setState({
        user: {
          lastname: state['user[lastname]'],
          firstname: state['user[firstname]'],
          login: state['user[login]'],
          password: state['user[password]'],
          phone_number: state['user[phone_number]']
        }
      });
    }
    component.setState({
      step: state.step + 1
    });
  };
  validate = e => {
    const component = this,
      props = this.props,
      state = this.state;
    if (state.loading === true) return;
    component.setState({
      loading: true
    });
    const subscription = getFormData({
      state: state,
      pattern: 'user['
    });
    qwest.post(action('CreateSubscriptionPayment'), subscription).then(function (xhr, response) {
      if (props.type === 'update') {
        component.fetchBooking();
      } else {
        const url = app.state.session.user?.roles?.includes?.('admin') ? URL('PreSubscriptionsDashboard') : URL('AdminSubscriptionsDashboard');
        return app.navigateTo(url);
      }
      component.setState({
        loading: false,
        info: response.info,
        error: undefined,
        warning: undefined,
        status_messages: {}
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  selectCustomer = customer_id => {
    const component = this,
      props = this.props,
      state = this.state;
    if (!state.cutomer_search_result || !customer_id) return;
    let customer = (state.cutomer_search_result || []).find(customer => customer.id === customer_id);
    component.setState({
      'user[lastname]': customer.lastname || '',
      'user[firstname]': customer.firstname || '',
      'user[login]': customer.login || '',
      'user[phone_number]': customer.phone_number || '',
      'user[id]': customer.id || '',
      user: customer,
      create_account: false,
      step: 1
    });
  };
  handlePhoneChange = value => {
    const component = this,
      props = this.props,
      state = this.state;
    component.handleChange({
      e: undefined,
      value: value,
      name: 'user[phone_number]'
    });
  };
  goBack = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      step: state.step - 1
    });
  };
  handleClickShowPassword = e => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      showPassword: !state.showPassword
    });
  };
  handleMouseDownPassword = e => {
    const component = this,
      props = this.props,
      state = this.state;
    e.preventDefault();
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const loader = state.loading === true ? /*#__PURE__*/React.createElement(Loader, {
      className: "c-loader",
      bemit: ['white', 'bg-primary']
    }) : undefined;
    let output = /*#__PURE__*/React.createElement("form", {
      method: "POST",
      action: action('CreateSubscriptionPayment'),
      className: props.paper !== false ? 'c-paper' : undefined,
      onSubmit: e => e?.preventDefault?.()
    }, state.step === 0 ? /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(CustomerPicking, {
      status: state.status_messages,
      cutomer_search_result: state.cutomer_search_result,
      selectCustomer: component.selectCustomer,
      loader: loader,
      handleChange: component.handleChange,
      customer_searched: state.customer_searched,
      searchCustomer: component.searchCustomer
    }), state?.cutomer_search_result && state?.cutomer_search_result.length === 0 ? /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("p", {
      className: "u-text-center u-margin-top-20"
    }, "Ou cr\xE9er un client"), /*#__PURE__*/React.createElement(Grid, {
      container: true,
      spacing: 2
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      className: "c-form-element c-form-element--reservation",
      value: state['user[lastname]'],
      name: "user[lastname]",
      label: "Nom",
      variant: "outlined",
      status: state.status_messages
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      className: "c-form-element c-form-element--reservation",
      value: state['user[firstname]'],
      name: "user[firstname]",
      label: "Pr\xE9nom",
      variant: "outlined",
      status: state.status_messages
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, /*#__PURE__*/React.createElement(MuiPhoneNumber, {
      onChange: component.handlePhoneChange,
      className: "c-form-element c-form-element--reservation",
      value: state['user[phone_number]'],
      onlyCountries: ['fr'],
      defaultCountry: "fr",
      countryCodeEditable: true,
      label: "Num\xE9ro de t\xE9l\xE9phone",
      variant: "outlined",
      fullWidth: true
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      value: state['user[login]'],
      className: "c-form-element c-form-element--reservation",
      name: "user[login]",
      type: "text",
      label: "E-mail",
      autocomplete: "new-email",
      variant: "outlined",
      status: state.status_messages
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      value: state['user[password]'],
      required: true,
      name: "user[password]",
      type: state.showPassword ? 'text' : 'password',
      label: "Mot de passe (12 caract\xE8res min.)",
      className: "c-form-element c-form-element--reservation",
      variant: "outlined",
      autocomplete: "new-password",
      suffix: /*#__PURE__*/React.createElement(InputAdornment, {
        position: "end"
      }, /*#__PURE__*/React.createElement(IconButton, {
        "aria-label": "Voir le mot de passe",
        onClick: component.handleClickShowPassword,
        onMouseDown: component.handleMouseDownPassword,
        edge: "end"
      }, state.showPassword ? /*#__PURE__*/React.createElement(Visibility, null) : /*#__PURE__*/React.createElement(VisibilityOff, null))),
      status: state.status_messages
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      value: state['password-verification'],
      required: true,
      name: "password-verification",
      type: state.showPassword ? "text" : "password",
      label: "Retapez le mot de passe (12 caract\xE8res min.)",
      className: "c-form-element c-form-element--reservation",
      variant: "outlined",
      autocomplete: "new-password",
      suffix: /*#__PURE__*/React.createElement(InputAdornment, {
        position: "end"
      }, /*#__PURE__*/React.createElement(IconButton, {
        "aria-label": "Voir le mot de passe",
        onClick: component.handleClickShowPassword,
        edge: "end",
        onMouseDown: component.handleMouseDownPassword
      }, state.showPassword ? /*#__PURE__*/React.createElement(Visibility, null) : /*#__PURE__*/React.createElement(VisibilityOff, null))),
      status: state.status_messages
    }))), /*#__PURE__*/React.createElement("div", {
      className: "u-full-width u-text-center\r u-margin-top-25 u-padding-bottom-20 "
    }, /*#__PURE__*/React.createElement(Button, {
      className: bemit('c-flat-btn', ['primary']),
      onClick: component.nextStep
    }, "Valider", loader))) : undefined) : /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "c-form u-full-width"
    }, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      className: "c-form-element c-form-element--reservation",
      value: state['user[lastname]'],
      name: "user[lastname]",
      label: "Nom",
      variant: "outlined",
      "read-only": true,
      status: state.status_messages
    }), /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      className: "c-form-element c-form-element--reservation",
      value: state['user[firstname]'],
      name: "user[firstname]",
      label: "Pr\xE9nom",
      variant: "outlined",
      "read-only": true,
      status: state.status_messages
    }), /*#__PURE__*/React.createElement(MuiPhoneNumber, {
      onChange: component.handlePhoneChange,
      className: "c-form-element c-form-element--reservation",
      value: state['user[phone_number]'],
      onlyCountries: ['fr'],
      defaultCountry: "fr",
      countryCodeEditable: true,
      label: "Num\xE9ro de t\xE9l\xE9phone",
      variant: "outlined",
      disabled: true,
      fullWidth: true
    }), /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      value: state['user[login]'],
      className: "c-form-element c-form-element--reservation",
      name: "user[login]",
      type: "text",
      label: "E-mail",
      autocomplete: "new-email",
      variant: "outlined",
      "read-only": true,
      status: state.status_messages
    }), /*#__PURE__*/React.createElement("div", {
      className: "c-form-element c-form-element--reservation"
    }, /*#__PURE__*/React.createElement(Button, {
      className: bemit('c-flat-btn', ['primary']),
      onClick: component.validate
    }, "Valider et envoyer le mail de paiement d'abonnement", loader)))));
    return output;
  }
}
